// @flow
import React from "react";
import PropTypes from "prop-types";
import { Input, Icon, Divider, Tag, Tooltip } from "antd";
import { connect } from "react-redux";
import { compose } from "recompose";
import Media from "react-media";
import * as actions from "../../actions";
import { withLoading } from "../hoc";
import type { State } from "../../types/store";
import type { Entities } from "../../types/entities";
import "./mainFilters.css";

const { CheckableTag } = Tag;
const Search = Input.Search;

type Props = {
  searchString: Object,
  typologies: Entities,
  markets: Entities,
  selectedMarkets: Array<string>,
  selectedTypologies: Array<string>,
  onSetSearchString: Function,
  onSetMarket: Function,
  onToggleMarket: Function,
  onToggleTypology: Function,
  onSetTypology: Function
};

let MainFilters = ({
  searchString,
  typologies,
  markets,
  selectedTypologies,
  selectedMarkets,
  onSetSearchString,
  onToggleTypology,
  onSetTypology,
  onSetMarket,
  onToggleMarket
}: Props) => {
  const marketChange = (value, checked) => {
    onToggleMarket(value);
  };

  // const typologyChange = value => {
  //   onSetTypology(value);
  // };

  const toggleTypology = (value, checked) => {
    onToggleTypology(value);
  };

  const textSearchChange = event => {
    onSetSearchString(event.target.value);
  };
  // const onTextSearch = value => {
  //   onSetSearchString(value);
  // };
  let searchInput;
  const emitEmptySearch = () => {
    // console.log("searchInput ", searchInput);
    if (searchInput) searchInput.focus();
    onSetSearchString("");
  };

  // const defaultMarket = markets.all[0];
  const { text: _searchString } = searchString;
  const prefix = _searchString ? (
    <Icon type="close-circle" onClick={emitEmptySearch} />
  ) : null;

  const onResetMarkets = () => {
    onSetMarket([]);
  };

  const resetMarkets = selectedMarkets.length ? (
    <Icon type="close-circle" onClick={onResetMarkets} />
  ) : null;

  const onResetTypologies = () => {
    onSetTypology([]);
  };

  const resetTypologies = selectedTypologies.length ? (
    <Icon type="close-circle" onClick={onResetTypologies} />
  ) : null;

  return (
    <div className="main-filters">
      <Search
        style={{
          marginBottom: 20
        }}
        placeholder="Input search text"
        prefix={prefix}
        value={searchString.text}
        onChange={textSearchChange}
        ref={node => (searchInput = node)}
        // onSearch={onTextSearch}
      />
      {markets.all.length > 0 && (
        <div>
          {markets.all.length > 1 ? (
            <div>
              <Divider className="filters-label">
                Markets {resetMarkets}
              </Divider>
              <div className="markets-wrapper search-panel-element">
                {markets.all.map(_id => {
                  const { id, name } = markets.byId[_id];
                  return (
                    <CheckableTag
                      key={id}
                      className="market-tag"
                      checked={selectedMarkets.indexOf(id) > -1}
                      onChange={checked => marketChange(id, checked)}
                    >
                      {name}
                    </CheckableTag>
                  );
                })}
              </div>
            </div>
          ) : (
            <Divider className="filters-label">
              {markets.byId[markets.all[0]].name} Market
            </Divider>
          )}
        </div>
      )}

      <Divider className="filters-label">Typologies {resetTypologies}</Divider>
      <div className="typology-wrapper search-panel-element">
        <Media query="(hover: hover)">
          {matches => {
            return typologies.all.map(_id => {
              const { id, name, icon } = typologies.byId[_id];
              return matches ? (
                <Tooltip
                  key={id}
                  title={name}
                  placement="topLeft"
                  arrowPointAtCenter
                  mouseLeaveDelay={0}
                  getPopupContainer={triggerNode => triggerNode.parentNode}
                >
                  <CheckableTag
                    className="typology-tag"
                    checked={selectedTypologies.indexOf(id) > -1}
                    onChange={checked => toggleTypology(id, checked)}
                  >
                    <Icon className="icon" type={icon} />
                  </CheckableTag>
                </Tooltip>
              ) : (
                <CheckableTag
                  key={id}
                  className="typology-tag"
                  checked={selectedTypologies.indexOf(id) > -1}
                  onChange={checked => toggleTypology(id, checked)}
                >
                  <Icon className="icon" type={icon} />
                </CheckableTag>
              );
            });
          }}
        </Media>
      </div>
    </div>
  );
};

const loadingCondition = props => props.isLoading;

MainFilters = compose(withLoading(loadingCondition))(MainFilters);

function mapStateToProps(state: State) {
  const { isLoading, searchString } = state.filters.mainFilters;
  const {
    entities: typologies,
    selectedTypologies
  } = state.filters.mainFilters.typologies;
  const {
    entities: markets,
    selectedMarkets
  } = state.filters.mainFilters.markets;
  return {
    isLoading,
    searchString,
    markets,
    typologies,
    selectedMarkets,
    selectedTypologies
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onSetSearchString: text => {
      dispatch(actions.setSearchString(text));
    },
    onSetTypology: ids => {
      dispatch(actions.setTypology(ids));
    },
    onToggleTypology: id => {
      dispatch(actions.toggleTypologyOnSelectedList(id));
    },
    onSetMarket: ids => {
      dispatch(actions.setMarket(ids));
    },
    onToggleMarket: id => {
      dispatch(actions.toggleMarketOnSelectedList(id));
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MainFilters);

MainFilters.propTypes = {
  searchString: PropTypes.object.isRequired,
  markets: PropTypes.object.isRequired,
  typologies: PropTypes.object.isRequired,
  selectedMarkets: PropTypes.array,
  selectedTypologies: PropTypes.array,
  onSetSearchString: PropTypes.func.isRequired,
  onSetMarket: PropTypes.func.isRequired,
  onToggleMarket: PropTypes.func.isRequired,
  onToggleTypology: PropTypes.func.isRequired,
  onSetTypology: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/components/mainfilters/index.js